import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-shuffle",
  templateUrl: "./med-icon-shuffle.component.html",
})
export class MedIconShuffleComponent extends SvgMixinComponent {}
